import React from "react";
import { Checkbox as AntdCheckbox } from "antd";

const Checkbox = (props) => {
  return <AntdCheckbox {...props}>{props.children}</AntdCheckbox>;
};

export default Checkbox;
